import(/* webpackMode: "eager" */ "/app/apps/nivex-frontend/src/app/(auth)/error.tsx");
